import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { stringToDate } from 'modules/core/lib/dates'

const UNLIMITED_NEGATIVE_TRANSFERS_RELEASE_DATE = '2024-06-27'

const useIsAccessInAutoApprovalGroup = () => {
  const {
    company: { createdAt: companyCreatedAt },
  } = useCurrentSession()
  const releaseDate = stringToDate(UNLIMITED_NEGATIVE_TRANSFERS_RELEASE_DATE, 'backend')

  return releaseDate.isSameOrBefore(companyCreatedAt)
}

export default useIsAccessInAutoApprovalGroup
